
import { Component } from 'react'

import { SupportingDocumentationQuestionnaire } from '../../../../../../../lib/Questionnaires'
import {
  YesNoRadioOptions,
  bindTargetMixin,
  CancelButton,
  escapeCancel,
  QuestionRadioButtonInput,
  SaveButton
} from '../../../../../../shared/FormBuilder'
import { Paper } from '../../../../../../shared/NarusMaterial'

import { style } from './style'

class POST extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    this.state = {
      value: { ...props.value }
    }
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
  }

  getValues () {
    return { ...this.state.value }
  }

  handleFormSubmit () {
    const { handleSubmit } = this.props
    handleSubmit(this.getValues())
    this.setState({
      isSubmitting: true
    })
  }

  handleKeyDown (e) {
    escapeCancel(e, this.props.cancel)
  }

  render () {
    const documentation =
      this.state.value.PPHave === 'yes' && !this.state.value.PPNarusCopy

    const disableSave = !this.state.value.PPHave || documentation

    return (

      <form
        onKeyDown={this.handleKeyDown}
        className='margin-top margin-bottom col-xs-12'
      >
        <Paper>
          <h2 className='col-xs-12'> POST / POLST </h2>

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.PPHave}
            required
          />

          <div
            className='col-xs-12 margin-top'
            style={style.subHead}
          >
            {' '}
            If, yes?
          </div>

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.PPNarusCopy}
            required={this.state.value.PPHave === 'yes'}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.PPChanges}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.PPCopies}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.PPQuestions}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            question='Do we need to send copies of the POST / POLST to the medical team?'
            {...SupportingDocumentationQuestionnaire.PPSendCopies}
          />

          <div
            className='col-xs-12 margin-top'
            style={style.subHead}
          >
            {' '}
            If, no?
          </div>

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.PPLearning}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.PPComplete}
          />

          <div
            className='row margin-top end-xs'
            style={style.marg}
          >
            <div className='col-xs-offset-8 col-xs-4'>
              <CancelButton onClick={this.props.cancel} />
              <SaveButton
                disabled={disableSave || this.state.isSubmitting}
                onClick={this.handleFormSubmit}
              />
            </div>
          </div>
        </Paper>
      </form>
    )
  }
}

export default POST
